import React from 'react';
import { connect } from 'react-redux';
import StatisticsByReactivationContent from './StatisticsByReactivationContent.js';
import { actions } from './StatisticsByReactivationContent.actions';

const StatisticsByReactivationContentComponent = connect(
    function mapStateToProps(state) {
        const storedMetrics = state?.statistics?.data?.parameters?.metricsBinary
            || state?.serverStorage?.store?.reportByReactivation?.metrics;
        return {
            loadingData: state.statistics.data.loading,
            totalPages: state.statistics.data.total,
            page: state.statistics.data.page,
            metrics: typeof storedMetrics === 'string' ? storedMetrics : '',
            serverStorageReady: !!state.serverStorage.loaded
        };
    },
    function mapDispatchToProps(dispatch) {
        return {
            search: actions.search,
            setQuery: actions.setQuery
        };
    }
)(StatisticsByReactivationContent);

export default StatisticsByReactivationContentComponent;
